module.exports = __webpack_public_path__ + "media/assets/icons/quill/align-left-c364f1d8e8dc8909ef287bdbcd3e70c2.svg";